import React, { useState, forwardRef } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

type Props = MuiTextFieldProps;

/**
 * forwardRef used here because there was an issue reading the onboarding user profile form values without it
 */
const PasswordField = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const { InputProps: propsInputProps, ...restProps } = props;

    return (
        <MuiTextField
            ref={ref}
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            InputProps={{
                ...propsInputProps,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={toggleShowPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...restProps}
        />
    );
});

PasswordField.displayName = 'PasswordField';

export default PasswordField;
